import React, { useEffect, useRef } from "react";

const SearchComponent = ({
  searchedResult,
  setSearchQuery,
  searchQuery,
  searchLoading,
  setIsSearchOpen,
  setHeadingClicked,
  onResultClick,
}) => {
  const inputRef = useRef(null);

  useEffect(() => {
    requestAnimationFrame(() => inputRef.current?.focus());
  }, []);

  const handleClick = (resultId) => {
    setIsSearchOpen(false);
    setHeadingClicked?.(false);
    if (onResultClick) onResultClick(resultId);
  };

  return (
    <div className="dialog">
      <div className="dialog-header">
        <span aria-hidden="true">⌕</span>
        <label className="sr-only" id="searchLabel" htmlFor="searchInput">
          Search ScrollX Help
        </label>
        <input
          ref={inputRef}
          id="searchInput"
          type="search"
          placeholder="Search ScrollX Help…"
          autoComplete="off"
          value={searchQuery}
          onChange={(event) => setSearchQuery(event.target.value)}
        />
        <button
          className="icon-button"
          type="button"
          aria-label="Close search"
          onClick={() => setIsSearchOpen(false)}
        >
          ×
        </button>
      </div>
      <div className="dialog-body" aria-live="polite">
        {searchQuery === "" ? (
          <div className="empty">
            Type a word or phrase to search articles and troubleshooting steps.
          </div>
        ) : searchLoading ? (
          <div className="empty">Searching…</div>
        ) : searchedResult?.length ? (
          searchedResult.map((result) => {
            const startIdx = result.idx || 0;
            const endIdx = startIdx + searchQuery.length;
            return (
              <button
                className="search-result"
                type="button"
                key={result._id}
                onClick={() => handleClick(result._id)}
              >
                <small>{result.subheading}</small>
                <strong>{result.tertiarySubHeading}</strong>
                <p>
                  {(result.snippet || "").substring(0, startIdx)}
                  <mark>{(result.snippet || "").substring(startIdx, endIdx)}</mark>
                  {(result.snippet || "").substring(endIdx)}
                </p>
              </button>
            );
          })
        ) : (
          <div className="empty">
            <strong>No results for “{searchQuery}”</strong>
            <br />
            Try a product term such as render, logo, billing, or project.
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchComponent;
